import { STATUS_VARIANT_HIGHLIGHT, StatusType } from '@/components/StatusWrapper/const';
import PendingStatusIcon from '@/images/BlcStatusesIcons/PendingStatusIcon.svg?react';
import FailedStatusIcon from '@/images/BlcStatusesIcons/FailedStatusIcon.svg?react';
import {
  SECURE_LINK_EXPIRY_DB,
  SECURE_LINK_STATUS_DB,
  SECURE_LINK_VIA_DB,
  VAULT_ACCOUNT_STATUS_DB,
} from '@/types/myVaultTypes';

export const VAULT_ACCOUNT_STATUS_TEXT = {
  [VAULT_ACCOUNT_STATUS_DB.PENDING]: 'Pending',
  [VAULT_ACCOUNT_STATUS_DB.PENDING_CONFIRMATION]: 'Pending confirmation',
  [VAULT_ACCOUNT_STATUS_DB.CONFIRMED]: 'Confirmed',
  [VAULT_ACCOUNT_STATUS_DB.INCOMPLETE]: 'Incomplete',
  [VAULT_ACCOUNT_STATUS_DB.FAILED]: 'Failed',
  [VAULT_ACCOUNT_STATUS_DB.CLOSED]: 'Closed',
};

export const VAULT_ACCOUNT_STATUS_MAP: StatusType = {
  [VAULT_ACCOUNT_STATUS_DB.PENDING]: { variant: STATUS_VARIANT_HIGHLIGHT.BLUE, statusIcon: <PendingStatusIcon /> },
  [VAULT_ACCOUNT_STATUS_DB.PENDING_CONFIRMATION]: { variant: STATUS_VARIANT_HIGHLIGHT.YELLOW },
  [VAULT_ACCOUNT_STATUS_DB.CONFIRMED]: { variant: STATUS_VARIANT_HIGHLIGHT.GREEN },
  [VAULT_ACCOUNT_STATUS_DB.INCOMPLETE]: { variant: STATUS_VARIANT_HIGHLIGHT.YELLOW },
  [VAULT_ACCOUNT_STATUS_DB.FAILED]: { variant: STATUS_VARIANT_HIGHLIGHT.RED, statusIcon: <FailedStatusIcon /> },
  [VAULT_ACCOUNT_STATUS_DB.CLOSED]: { variant: STATUS_VARIANT_HIGHLIGHT.GREY },
};

export const SECURE_LINK_STATUS_MAP: StatusType = {
  [SECURE_LINK_STATUS_DB.ACTIVE]: { variant: STATUS_VARIANT_HIGHLIGHT.GREEN },
  [SECURE_LINK_STATUS_DB.VIEWED]: { variant: STATUS_VARIANT_HIGHLIGHT.BLUE },
  [SECURE_LINK_STATUS_DB.PENDING_VERIFICATION]: { variant: STATUS_VARIANT_HIGHLIGHT.YELLOW },
  [SECURE_LINK_STATUS_DB.COMPLETED]: { variant: STATUS_VARIANT_HIGHLIGHT.GREEN },
  [SECURE_LINK_STATUS_DB.EXPIRED]: { variant: STATUS_VARIANT_HIGHLIGHT.GREY },
  [SECURE_LINK_STATUS_DB.REVOKED]: { variant: STATUS_VARIANT_HIGHLIGHT.RED },
};

export const SECURE_LINK_VIA_LABEL = {
  [SECURE_LINK_VIA_DB.EMAIL]: 'Email',
  [SECURE_LINK_VIA_DB.SMS]: 'Text message',
  // TODO: does not support for now
  // [SECURE_LINK_VIA_DB.WHATSAPP]: 'WhatsApp',
  // [SECURE_LINK_VIA_DB.TELEGRAM]: 'Telegram',
  [SECURE_LINK_VIA_DB.COPY]: 'Copy link',
};

export const SECURE_LINK_EXPIRY_LABEL = {
  [SECURE_LINK_EXPIRY_DB.H24]: '24 hours',
  [SECURE_LINK_EXPIRY_DB.D7]: '7 days',
  [SECURE_LINK_EXPIRY_DB.D30]: '30 days',
};

export const CLOSED_TAB = 'closed';
export const WIDE_FIELD_KEYS = ['beneficiary_address', 'bank_address', 'intermediary'];

export const ACCOUNT_TYPES_OPTIONS = [
  { value: 'checking', label: 'Checking' },
  { value: 'savings', label: 'Savings' },
];
